export default {
    //DEMO ENV
    // region: 'us-east-1',
    // IdentityPoolId: 'us-east-1_lPsGMCeW4',
    // UserPoolId: 'us-east-1:903214779126',
    // ClientId: '4b499ber6aqm3grisqgdau1oji',
    // userPoolLoginKey : 'cognito-idp.us-east-1.amazonaws.com/us-east-1_lPsGMCeW4',
    // IdentityPoolIdFileUpload : 'us-east-1:10995da6-d9a5-4ae5-85d1-fc9fc4f16a53',
    // albumBucketName : 'trade-recap/csv',
    // baseUrl : 'https://4v4loe9dji.execute-api.us-east-1.amazonaws.com/demo',
    // googleChartApiKey : "AIzaSyAtnz69n1b6IybcC4jvhEG28htrBlb44Js",
    // baseUrlBidSide : "https://cqtsm1unh8.execute-api.us-east-1.amazonaws.com/dev-env",
    // websocketConnection : "/demo-websockets",
    // websocketConnectionOfferSide : "/offering-websockets",
    // albumBucketNameIms : "imsfileupload"
    //PRODUCTION ENV
    region: 'us-east-1',
    IdentityPoolId: 'us-east-1_mIIUJmeM4',
    UserPoolId: 'us-east-1:903214779126',
    ClientId: 'bfv2vhkff48ganktvg2td5r5r',
    userPoolLoginKey : 'cognito-idp.us-east-1.amazonaws.com/us-east-1_mIIUJmeM4',
    IdentityPoolIdFileUpload : 'us-east-1:0fc78d93-440d-4a73-a867-a08d7df241a4',
    albumBucketName : 'trade-recap/csv',
    baseUrl : 'https://prod-api.drlgroup.app',
    googleChartApiKey : "AIzaSyAtnz69n1b6IybcC4jvhEG28htrBlb44Js",
    baseUrlBidSide : "https://i63n9aboj3.execute-api.us-east-1.amazonaws.com/prod",
    baseUrlAutoBidder : "https://myvzo22syg.execute-api.us-east-1.amazonaws.com/production",
    websocketConnection : "/tradebook-bidside-websockets",
    websocketConnectionOfferSide : "/offering-websockets",
    albumBucketNameIms : "imsfileuploadprod",
    baseUrlLamda : "https://xkomlqfenhgzs4sggn6oolhifi0phean.lambda-url.us-east-1.on.aws/"



    
}